import { cn } from '@utils/cn';
import React from 'react';

interface CardProps extends React.HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode;
  className?: string;
}

export const Card = ({ children, className, ...props }: CardProps) => {
  return (
    <div
      className={cn(
        'rounded-md bg-white dark:bg-gray-700 shadow-lg ring-1 ring-gray-900/5 dark:ring-white/10 p-6',
        className,
      )}
      {...props}>
      {children}
    </div>
  );
};
